import React, { useState } from 'react'
import { IconCopyCheck, IconCopy } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

/**
 * @import import { CopyButton } from '@/components/buttons/CopyButton'
 * @param {object} props
 * @param {string} props.content Text written to the clipboard on click
 * @param {string} [props.name] Label suffix, rendered as "Copy {name}"
 * @param {boolean} [props.showTooltip] Shows a tooltip describing what gets copied
 * @param {node} [props.tooltipContent] Custom tooltip content shown when showTooltip is true, defaults to quoting the copied text
 * @param {boolean} [props.iconOnly] Icon-only square button without the label
 * @param {function} [props.onCopy] Called after the text is written to the clipboard
 */
export const CopyButton = ({
  content,
  name = '',
  showTooltip = false,
  tooltipContent = null,
  iconOnly = false,
  onCopy = undefined,
  ...props
}) => {
  const [textCopied, setTextCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(content)
    setTextCopied(true)
    onCopy?.()
    setTimeout(() => setTextCopied(false), 1000)
  }

  return (
    <Button
      size={iconOnly ? 'xs' : 'small'}
      data-testid="copy-button"
      square={iconOnly}
      disabled={textCopied}
      onClick={handleCopy}
      tooltip={showTooltip ? tooltipContent || `Copy "${content}"` : null}
      {...props}
    >
      {textCopied ? <IconCopyCheck /> : <IconCopy />}
      {!iconOnly && (textCopied ? 'Copied!' : `Copy ${name}`)}
    </Button>
  )
}
